import { NetworkType } from '@capsicum/common';

export interface ReceiveFanTokens {
	id?: string;
	label?: string;
	logo?: string;
	maxAmount?: string;
	shortCode?: string;
}
export interface ReceiveDetails {
	receiveFantokens?: Array<ReceiveFanTokens>;
	remainingAmountBeforeLimit?: {
		formattedMaxAmount?: string;
		maxAmount?: string;
	};
}

// Currencies
export const enum CurrencyType {
	CHILIZ = 'chiliz',
	FANTOKENS = 'fanTokens'
}
export type ReceiveCurrencies = CurrencyType.CHILIZ | CurrencyType.FANTOKENS;

export const CURRENCY_LABELS = {
	[CurrencyType.CHILIZ]: 'Chiliz (CHZ)',
	[CurrencyType.FANTOKENS]: 'Fan Tokens'
};

export const CURRENCY_SHORTCODES = {
	[CurrencyType.CHILIZ]: 'CHZ',
	[CurrencyType.FANTOKENS]: 'FT'
};

export type ReceiveNetworks = NetworkType.CC1 | NetworkType.CC2 | NetworkType.ETHEREUM;

export const RECEIVE_NETWORK_LABELS = {
	[NetworkType.CC1]: 'Chiliz Legacy Chain',
	[NetworkType.CC2]: 'Chiliz Chain',
	[NetworkType.ETHEREUM]: 'Ethereum'
};

export const RECEIVE_NETWORK_SHORTCODES = {
	[NetworkType.CC1]: 'ERC-20',
	[NetworkType.CC2]: 'CAP-20',
	[NetworkType.ETHEREUM]: 'ERC-20'
};
